import { Serializer } from "jsonapi-serializer";
import { DeleteProfile, CreateProfile, RestoreProfile, UpdateProfileRelations } from "../../api/typings/Profiles";
import { IApiResourceResponse } from "../../@typings/client";

export async function getCreateProfileData(data: CreateProfile): Promise<IApiResourceResponse<CreateProfile>> {
  return new Serializer("users_profiles", {
    keyForAttribute: "snake_case",
    attributes: ["role", "user", "related_as_primary", "related_as_secondary"],
    related_as_primary: {
      ref: "id",
      included: false,
    },
    related_as_secondary: {
      ref: "id",
      included: false,
    },
    transform(record: CreateProfile) {
      record.related_as_primary = record.related_as_primary || [];
      record.related_as_secondary = record.related_as_secondary || [];
      return record;
    },
    typeForAttribute(attribute: any, record: any) {
      if (attribute === "user") return "users";
      return record && record.type ? record.type : attribute;
    },
    user: {
      ref: "id",
    },
  }).serialize(data);
}

export async function getDeleteProfileData(data: DeleteProfile): Promise<IApiResourceResponse<DeleteProfile>> {
  return new Serializer("users_profiles", {
    keyForAttribute: "snake_case",
    attributes: ["deleted_at"],
  }).serialize(data);
}

export async function getRestoreProfileData(data: RestoreProfile): Promise<IApiResourceResponse<RestoreProfile>> {
  return new Serializer("users_profiles", {
    keyForAttribute: "snake_case",
    attributes: ["deleted_at"],
  }).serialize(data);
}

export async function getUpdateProfileRelationsData(
  data: UpdateProfileRelations
): Promise<IApiResourceResponse<UpdateProfileRelations>> {
  return new Serializer("users_profiles", {
    keyForAttribute: "snake_case",
    attributes: ["related_as_primary", "related_as_secondary"],
    related_as_primary: {
      ref: "id",
      included: false,
    },
    related_as_secondary: {
      ref: "id",
      included: false,
    },
    transform(record: CreateProfile) {
      record.related_as_primary = record.related_as_primary || [];
      record.related_as_secondary = record.related_as_secondary || [];
      return record;
    },
    typeForAttribute(attribute: any, record: any) {
      return record && record.type ? record.type : attribute;
    },
  }).serialize(data);
}
